/* eslint-disable jsx-a11y/label-has-associated-control */

/* eslint-disable react/button-has-type */

/* eslint-disable react/no-array-index-key */

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable no-prototype-builtins */

/* eslint-disable no-console */

/* eslint-disable no-plusplus */

/* eslint-disable no-param-reassign */

/* eslint-disable prefer-const */

/* eslint-disable guard-for-in */

/* eslint-disable no-restricted-syntax */

/* eslint-disable no-unused-expressions */

/* eslint-disable react/destructuring-assignment */

/* eslint-disable react/prop-types */

/* eslint-disable max-len */

/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import { Services } from '@gscope-mfe/app-bridge';
import { Utilities } from '@gscope-mfe/app-bridge';
import { AppUtils } from '@gscope-mfe/app-bridge';
import { localizeCommonLang } from '../LocalizeLang';
import styles from './SearchCriteria.module.css';
import { getSpecificComponent } from './InputType';
import { InputTextField, InputNumberField } from '../InputField';
import {
    SelectTextField,
    MultiSelectTextField,
    SelectNumberField,
    MultiSelectNumberField,
    MultiSelectizeText,
} from '../SelectField';
import DatePicker from '../DateRange';
import { CustomToolTip } from '../ToolTips';
const { TextField } = MaterialUiCore;
const { Checkbox } = MaterialUiCore;
const { convertListToMap, parseResponse } = Utilities;
const { manageUserPref } = Services;

const SearchCriteria = (props) => {
    const { userInfo } = AppUtils.get();
    const loggedInUserId = userInfo.loggedInUserName;
    const rawData = props.filterOptions;
    const { preferenceValue } = props;
    const addtionalSettings = props.settings;
    let filterOptions = {};
    let selectedFilters = [];
    let savedFilter;
    let SpecificComponent;
    let filterOptionsKey;
    const t = localizeCommonLang();
    /**
     * Check if rawData is map, if not convert it to map
     */

    Array.isArray(rawData) ? (filterOptions = convertListToMap(rawData, 'filterName')) : (filterOptions = rawData);
    /** Get user preference from localstorage
     *  Get value of applied filters based on localstorage, else use props.appliedFilter
     */

    const getUserPref = () => {
        const pref = localStorage.getItem(`ngStorage-preferences_${loggedInUserId}`)
            ? JSON.parse(localStorage.getItem(`ngStorage-preferences_${loggedInUserId}`))
            : {};

        if (Object.keys(pref).length) {
            const savedPref = pref[preferenceValue.pageName][preferenceValue.key];

            if (savedPref && Object.keys(savedPref).length) {
                return savedPref;
            }
        } else {
            return props.appliedFilters;
        }
    };
    /** MultiselectAddFilterControls State Variable */

    const [toggleIconValue, setToggleIconValue] = React.useState({
        value: false,
        icon: 'Add-18',
    });
    const [appliedFilters, setAppliedFilters] = React.useState(getUserPref());
    const [filtersPayload, setFiltersPayload] = React.useState({});
    const [searchFilterOption, setSearchFilterOption] = React.useState('');
    /** Change render based on state property */

    const handleToggleIconValue = () => {
        setToggleIconValue({
            value: !toggleIconValue.value,
            icon: toggleIconValue.icon === 'Add-18' ? 'Minus-18' : 'Add-18',
        });
    };
    /** Initial Render of the filter components based on selected property */

    (() => {
        for (const key in filterOptions) {
            filterOptions[key].selected = filterOptions[key].selected ? filterOptions[key].selected : false;

            if (appliedFilters && Object.keys(appliedFilters).length > 0) {
                if (filterOptions[key].filterName in appliedFilters) {
                    filterOptions[key].selected = true;

                    if (selectedFilters.indexOf(filterOptions[key]) === -1) {
                        selectedFilters.push(filterOptions[key]);
                    }
                } else {
                    filterOptions[key].selected = false;
                    selectedFilters = selectedFilters.filter((item) => item !== filterOptions[key]);
                }
            }
        }
    })();

    filterOptionsKey = Object.keys(filterOptions);
    /** Add and remove filter component based on user interaction */

    const manageFilters = (option, event) => {
        option.selected = !option.selected;

        if (option.selected) {
            selectedFilters.push(option);
            setAppliedFilters({ ...appliedFilters, [option.filterName]: '' });
        } else {
            for (let i = 0; i < selectedFilters.length; i++) {
                const pop = selectedFilters[i];

                if (pop.filterName === option.filterName) {
                    selectedFilters.splice(i, 1);
                    break;
                }
            }

            delete appliedFilters[option.filterName];
            setAppliedFilters({ ...appliedFilters });
        }
    };
    /** On click of reset button, reset the rendered filters */

    const handleResetFilters = () => {
        setAppliedFilters(getUserPref());
    };

    const savePreferredFilters = async () => {
        const prefFilter = {
            userId: loggedInUserId,
            page: preferenceValue.pageName,
            preferenceName: preferenceValue.key,
            preferenceValue: JSON.stringify(appliedFilters),
        };
        const { data } = await manageUserPref(JSON.stringify(prefFilter));
        savedFilter = data;
        const pagePreference = parseResponse(savedFilter.payload.pagePreferences);

        if (savedFilter.status == 'OK') {
            localStorage.setItem(`ngStorage-preferences_${loggedInUserId}`, JSON.stringify(pagePreference));
        }

        setAppliedFilters(pagePreference[preferenceValue.pageName][preferenceValue.key]);
    };

    const setParentState = (item, val) => {
        if (filterOptionsKey.includes(item)) {
            setFiltersPayload({ ...filtersPayload, [item]: val });
        }
    };

    const handleView = (event) => {
        event.preventDefault();

        if (preferenceValue.setPrefOnSave) {
            savePreferredFilters();
            console.log('Todo:: API call to see the data ', filtersPayload);
        } else {
            console.log('Todo:: API call to see the data ', filtersPayload);
        }
    };

    const removeFilter = (option) => {
        if (option.selected) {
            option.selected = !option.selected;
            selectedFilters.forEach((item, index) => {
                if (item.filterName === option.filterName) {
                    selectedFilters.slice(index, 1);
                    delete appliedFilters[option.filterName];
                }
            });

            if (filtersPayload.hasOwnProperty(option.filterName)) {
                delete filtersPayload[option.filterName];
            }

            setAppliedFilters({ ...appliedFilters });
            setFiltersPayload({ ...filtersPayload });
        }
    };
    /** Search filters */

    const handleSearchFilter = (event) => {
        setSearchFilterOption(event.target.value);
        console.log('search text', searchFilterOption);
    };

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.filtersWrapper}>
                <CustomToolTip title="Add Criteria">
                    <div className={styles.addCriteria}>
                        <span
                            id="addCriteria"
                            className={`sct-icon icon-${toggleIconValue.icon}`}
                            onClick={handleToggleIconValue}
                            style={{
                                color: 'white',
                            }}
                        />
                    </div>
                </CustomToolTip>
                <div className={styles.loadFilterTemplates}>
                    {selectedFilters.length ? (
                        <>
                            {selectedFilters.map((item, index) => {
                                SpecificComponent = getSpecificComponent(item);
                                return (
                                    <div key={index} className={styles.filterType}>
                                        <SpecificComponent
                                            label={item.displayText}
                                            options={item.options}
                                            filterName={item.filterName}
                                            updateParentState={setParentState}
                                        />
                                        <span
                                            className="sct-icon icon-Remove-18"
                                            style={{
                                                fontSize: '16px',
                                                marginLeft: '12px',
                                                cursor: 'pointer',
                                            }}
                                            onClick={(evt) => removeFilter(item)}
                                        />
                                    </div>
                                );
                            })}
                        </>
                    ) : (
                        <span />
                    )}
                </div>
                {selectedFilters.length ? (
                    <div className={styles.actionBtn}>
                        <button className="textBtn textBtnEnabled" onClick={handleResetFilters}>
                            Reset
                        </button>
                        <button
                            className="primaryBtn primaryBtnEnabled"
                            style={{
                                marginRight: '12px',
                                border: 'none',
                            }}
                            onClick={handleView}
                        >
                            View
                        </button>
                        <div className={styles.heartBtn}>
                            {preferenceValue.setPrefOnSave ? (
                                <>
                                    <span className="sct-icon icon-Heart-18" onClick={savePreferredFilters} />
                                </>
                            ) : (
                                <span />
                            )}
                        </div>
                    </div>
                ) : (
                    <div> {toggleIconValue.icon === 'Add-18' ? 'Click + icon to add filters' : ''} </div>
                )}
            </div>
            <div className={styles.childrenEle}>{props.children}</div>
            {toggleIconValue.value ? (
                <>
                    <div className={styles.separator} />
                    <div className={styles.optionsWrapper}>
                        <div className={styles.searchOptions}>
                            <TextField
                                id="outlined-search"
                                type="search"
                                variant="outlined"
                                placeholder="Search Filter here.."
                                onChange={handleSearchFilter}
                            />
                        </div>
                        <div className={styles.filterOptions}>
                            {filterOptionsKey.map((item, key) => (
                                <div key={key} className={styles.option}>
                                    <label>
                                        <Checkbox
                                            style={{
                                                marginRight: '12px',
                                            }}
                                            checked={filterOptions[item].selected}
                                            onChange={(evt) => manageFilters(filterOptions[item], evt)}
                                        />
                                        {filterOptions[item].displayText}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            ) : (
                <span />
            )}
        </div>
    );
};

export default SearchCriteria;
